<script setup lang="ts">
import GoogleBrandIcon from "@/components/Icons/googleBrandIcon.vue";
import { useTheme } from "vuetify";

// Interface
interface Emits {
  (e: "clicked", value: string): void;
}

const { global } = useTheme();

// Emits
const emit = defineEmits<Emits>();

const authProviders = computed(() => {
  return [
    // {
    //   icon: "mdi-facebook",
    //   color: "#4267b2",
    //   colorInDark: "#4267b2",
    //   provider: "facebook",
    //   title: "Login with Facebook",
    //   textColor: "text-white",
    // },
    {
      icon: GoogleBrandIcon,
      color: "#000000",
      colorInDark: "#FFFF",
      provider: "google",
      title: "Sign in with Google",
      textColor: global.name.value === "dark" ? "text-black" : "text-white",
    },
  ];
});
</script>

<template>
  <VBtn
    v-for="{
      icon,
      color,
      colorInDark,
      provider,
      title,
      textColor,
    } in authProviders"
    :key="icon"
    :color="global.name.value === 'dark' ? colorInDark : color"
    :prepend-icon="icon"
    :class="textColor"
    size="small"
    variant="flat"
    class="mr-2"
    @click="emit('clicked', provider)"
  >
    {{ title }}
  </VBtn>
</template>
